import { PayloadAction } from "@reduxjs/toolkit";

import { AutocompleteItem } from "../../../components/Autocomplete";
import { FormType } from "../../../components/enums";
import { Url } from "../../../router/enums";
import { defaultCountry } from "../../../shared";
import {
  createGenericUISlice,
  GenericState,
  UIState,
} from "../../../store/HOC/genericUI.slice";

import { ComponentId } from "./enums";

export type FormDataInputs = {
  [ComponentId.VEHICLE_REGISTRATION_NUMBER]: string;
  [ComponentId.VEHICLE_MILEAGE]?: string;
  [ComponentId.VEHICLE_CITY]: string;
  [ComponentId.VEHICLE_DRIVEABLE]: string;
  [ComponentId.COUNTRY_REPAIR]: AutocompleteItem;
  [ComponentId.PROVINCE_REPAIR]: string;
  [ComponentId.CITY_REPAIR]: string;
  [ComponentId.IS_LEASE_CLIENT]: string;
};

type VehicleState = {
  data: FormDataInputs;
  ui: UIState;
};

const initialState: VehicleState = {
  data: {
    [ComponentId.VEHICLE_REGISTRATION_NUMBER]: "",
    [ComponentId.VEHICLE_CITY]: "",
    [ComponentId.VEHICLE_DRIVEABLE]: "",
    [ComponentId.COUNTRY_REPAIR]: {
      ...defaultCountry,
    },
    [ComponentId.PROVINCE_REPAIR]: "",
    [ComponentId.CITY_REPAIR]: "",
    [ComponentId.IS_LEASE_CLIENT]: "true",
  },
  ui: {
    [ComponentId.COUNTRY_REPAIR]: defaultCountry.value,
    validated: false,
  },
};

const vehicleSlice = createGenericUISlice({
  name: "@ac/vehicle",
  initialState: initialState as GenericState<FormDataInputs>,
  reducers: {
    setData: (state, action: PayloadAction<FormDataInputs>) => {
      state.data = action.payload;
      state.ui.validated = true;
    },
    setIsDriveable(state, action: PayloadAction<string>) {
      state.data[ComponentId.VEHICLE_DRIVEABLE] =
        initialState.data[ComponentId.VEHICLE_DRIVEABLE];
      state.data[ComponentId.VEHICLE_DRIVEABLE] = action.payload; // VEHICLE_DRIVEABLE - true/false
      state.data[ComponentId.IS_LEASE_CLIENT] = "true"; // IS_LEASE_CLIENT - true/false
      state.ui.redirect = initialState.ui.redirect;
      state.ui.redirect = Url.AC_APPLICANT;
    },
  },
});

export const {
  setData: setVehicleFormData,
  setUIField,
  setIsDriveable,
} = vehicleSlice.actions;

export const { reducer } = vehicleSlice;
